(() => {
  document.querySelectorAll('[data-pacifikava-page]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const video = root.querySelector('[data-farm-hero]');
    const audio = root.querySelector('.pf-audio');
    const phone = matchMedia('(max-width: 767px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      audio.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      audio.setAttribute('aria-pressed', String(!video.muted));
      audio.querySelector('.pf-muted').hidden = !video.muted;
      audio.querySelector('.pf-sound').hidden = video.muted;
    };
    const play = () => video.play().catch(() => {});
    const choose = () => {
      video.pause();
      video.muted = true;
      video.width = phone.matches ? 1260 : 1920;
      video.height = phone.matches ? 1800 : 1080;
      video.poster = phone.matches ? video.dataset.phonePoster : video.dataset.desktopPoster;
      video.src = phone.matches ? video.dataset.phoneSrc : video.dataset.desktopSrc;
      video.load();
      if (!reducedMotion.matches) play();
      sync();
    };
    audio.addEventListener('click', () => {
      video.muted = !video.muted;
      if (video.paused) play();
      sync();
    });
    video.addEventListener('volumechange', sync);
    video.addEventListener('keydown', event => {
      if (event.code === 'Space') { event.preventDefault(); video.paused ? play() : video.pause(); }
      if (event.code === 'KeyM') { event.preventDefault(); video.muted = !video.muted; sync(); }
    });
    phone.addEventListener('change', choose);
    choose();
  });
})();
